// @flow
import React, { useState } from 'react';
import { ConfirmModal } from '@presentational/modals/ConfirmModal';

export const useSequentialConfirmation = ({
  onClick,
  onCancel,
  shouldShowConfirmation = false,
  confirmationConfigs = [],
}) => {
  const [activeConfirmIndex, setActiveConfirmIndex] = useState(-1);

  const handleClick = () => {
    if (shouldShowConfirmation && confirmationConfigs.length > 0) {
      setActiveConfirmIndex(0);
    } else {
      onClick();
    }
  };

  const handleConfirm = () => {
    const nextIndex = activeConfirmIndex + 1;
    if (nextIndex < confirmationConfigs.length) {
      setActiveConfirmIndex(nextIndex);
    } else {
      setActiveConfirmIndex(-1);
      onClick();
    }
  };

  const handleCancel = () => {
    setActiveConfirmIndex(-1);
    if (onCancel) {
      onCancel();
    }
  };

  const activeConfig = confirmationConfigs[activeConfirmIndex];

  const {
    body,
    cancelButtonText = 'Cancel',
    fullScreen = false,
    header,
    okButtonText = 'Yes, proceed',
  } = activeConfig || {};

  const confirmModal = activeConfig ? (
    <ConfirmModal
      body={body}
      cancelButtonText={cancelButtonText}
      fullScreen={fullScreen}
      header={header}
      isOpen={true}
      okButtonText={okButtonText}
      onClickHandlerForCancel={handleCancel}
      onClickHandlerForOK={handleConfirm}
    />
  ) : null;

  return { handleClick, confirmModal };
};
